export const IDADE_ENUM = {
    sessentaCinco: 65,
    setentaCinco: 75
};

export const validarParentescoDependente = valoresForm => {
    const arrayDeValidacoes = [
        !verificarParentescoPermitido(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorDependenteComValorAdicional = valoresForm => {
    const arrayDeValidacoes = [
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorAte65AnosComAdicioanal = valoresForm => {
    const arrayDeValidacoes = [
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaAdicionalAte65(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaior65AnosComAdicional = valoresForm => {
    const arrayDeValidacoes = [
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarCategoriaAdicionalAcima65(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescoEmDuplicidade = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificaSeJaPossuiParentescoSelecionado(dependentes, valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificaSeJaPossuiParentescoSelecionado = (dependentes, values) => {
    const seq = values.Seq;
    const parentesco = values.Parentesco;
    const parentescosQuePodemSerMaisQueUm = ['5', '15', '50'];

    if (!parentesco) {
        return false;
    }

    if (parentescosQuePodemSerMaisQueUm.includes(parentesco.trim())) {
        return false;
    }

    const possuiParentescoSelecionado = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === parentesco.trim());

    if (!possuiParentescoSelecionado.length) {
        return false;
    }

    if (seq) {
        return seq !== possuiParentescoSelecionado[0].Seq;
    }

    return true;
};

export const validarLimiteCategoria = (dependentes, categoria, limit) => {
    const dependentesFiltrados = dependentes.filter(dependente => dependente['CategoriaParentesco.Categoria'] == categoria).length;

    return dependentesFiltrados < limit;
};

export const validarCategoria = (dependentes, categoria) => {
    const categoriaFiltro = categoria.trim() === 'ZTM65' ? 'ZTA64' : 'ZTM65';

    const dependenteCategoria = dependentes.filter(dependente => dependente['CategoriaParentesco.Categoria'] == categoriaFiltro).length;

    return !dependenteCategoria;
};

export const parentescosPermitidos = [
    '01',
    '02',
    '5',
    '15',
    '50',
    '20007',
    '20008'
];
const verificarParentescoPermitido = parentesco => {
    const parentescoEncontrado = parentescosPermitidos.find(itemParentesco => itemParentesco == parentesco);

    return parentescoEncontrado !== undefined ? true : false;
};

const verificarIdadePreenchida = idade => idade !== '' && idade !== null;
const verificarCategoriaPrenchida = categoria => categoria !== '';
const verificarParentescoPrenchido = parentesco => parentesco !== '';

const verificarCategoriaAdicionalAte65 = categoria => categoria.trim() !== 'ZTA64';
const verificarCategoriaAdicionalAcima65 = categoria => categoria.trim() !== 'ZTM65';
export const idadeAte65 = idade => idade <= IDADE_ENUM.sessentaCinco;
export const idadeAcima65 = idade => idade > IDADE_ENUM.sessentaCinco && idade <= IDADE_ENUM.setentaCinco;
export const idadeAcima75 = idade => idade > IDADE_ENUM.setentaCinco;
const parentescos = {
    '01': 'PAI',
    '02': 'MAE',
    '5': 'FILHO(A)',
    '15': 'SOGRO(A)',
    '50': 'FILHO(A) ADOTIVO',
    '20007': 'MADRASTA',
    '20008': 'PADRASTO'
};

export const retornaLabelDoValorParentesco = valueParentesco => {
    const parentesco = valueParentesco.trim();

    if (parentesco === '15') {
        return `Só é permitido dois dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    } else if (parentesco === '03') {
        return 'O Tipo de dependente não pertence ao plano selecionado.';
    }

    return `Só é permitido um dependente do tipo  ${parentescos[`${parentesco}`]}`;
};
